export default function (el, bindings, vNode) {
  const { value } = el
  const bindedRegexp = bindings.value
  let mask = bindedRegexp
    ? new RegExp(bindedRegexp, 'g')
    : /[^\d]/g

  el.value = value.replace(mask, '')
  vNode.elm.dispatchEvent(new CustomEvent('input'))
}
